import { Controller } from "@hotwired/stimulus"

// "Neuer Mitarbeiter-Bericht": narrows the employee picker to the people the chosen
// type may be filled out about. Each type option carries data-employee-ids (absent =
// anyone); a self-only type lists just the author, who is then picked right away.
export default class extends Controller {
  static targets = ["type", "employee", "selfOnlyHint"]

  filter() {
    const type = this.typeTarget.selectedOptions[0]
    const ids = type?.dataset.employeeIds ? JSON.parse(type.dataset.employeeIds).map(String) : null
    const allowed = ids ? new Set(ids) : null
    const selfOnly = type?.dataset.selfOnly === "true"
    const select = this.employeeTarget

    for (const option of select.options) {
      if (option.value === "") continue
      option.hidden = allowed !== null && !allowed.has(option.value)
    }
    // A selected option must never be hidden (the select controller would blank its value box).
    if (select.selectedOptions[0]?.hidden) select.value = ""
    if (selfOnly && ids.length === 1) select.value = ids[0]
    this.selfOnlyHintTarget.classList.toggle("hidden", !selfOnly)

    const slim = this.application.getControllerForElementAndIdentifier(select, "select")
    if (!slim) return

    slim.refresh()
    if (select.value === "") slim.clear()
  }
}
